import './retailer-info.scss';
import Header from '../../../organisms/header/header.js';
import RoleRibbonByRole from '../../../organisms/common/role-ribbon/role-ribbon-by-role';
import {Navigate, useLocation, useParams, useNavigate} from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import decodeToken from '../../../../utils/decode-token';
import apiClient from '../../../../utils/apiClient';
import { Alert, Snackbar } from '@mui/material';
import HacNavigation from "../../../organisms/common/hac-navigation/hac-navigation";
import { isPmaRole } from '../../../../utils/role-utils';
import BackButton from '../../../atoms/back-button';

function RetailerInfo() {
  const { t } = useTranslation();
  const token = sessionStorage.getItem('token') || null;
  const role = decodeToken(token).role;
  const { hacId } = useParams();
  //console.log(hacId);
  const navigate = useNavigate();
  const [contactInfo, setContactInfo] = useState(null);

  const location = useLocation();
  const { breadcrumbName } = location.state || {};

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  const fetchData = async () => {
    const authToken = token;
    const url = `${process.env.REACT_APP_API_URL}/pma/contact-info/hac/${hacId}`;

    const config = {
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Cache-Control': 'no-cache',
      },
    };

    try {
      const response = await apiClient.get(url, config);
      if (response.status === 200) {
        setContactInfo(response.data);
      }
    } catch (error) {
      if (error.response) {
        setSnackbarOpen(true);
        setSnackbarMessage(t('common-internal-server-error'), error);
      }
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {token && isPmaRole(role) ? (
        <div className="App">
          <Header />
          <RoleRibbonByRole role={role} navigate={navigate} translate={t} />
          <main>
            <section className="contact-info retailer-info">
              <div className="inner menu">
                <HacNavigation  />

                <main className="profile">
                  <BackButton fallbackTo="/pma/main/hac" context={breadcrumbName} />
                  <h2>{t('retailer-info-title')}</h2>
                  {contactInfo ? (
                    <>
                      <div className="retailer">
                        <h5>{t('retailer-info-title')}</h5>
                        <div>
                          <dl>
                            <div>
                              <dt>{t('common-name')}</dt>
                              <dd>{contactInfo.retailer.name}</dd>
                            </div>
                            <div>
                              <dt>{t('common-country')}</dt>
                              <dd>{t(`countries-${contactInfo.retailer.area_code}`)}</dd>
                            </div>
                            <div>
                              <dt>{t('common-city')}</dt>
                              <dd>{contactInfo.retailer.city}</dd>
                            </div>
                            <div>
                              <dt>{t('common-retailer-code')}</dt>
                              <dd>{contactInfo.retailer.retailer_code}</dd>
                            </div>
                          </dl>
                        </div>
                      </div>

                      {contactInfo.retailer_gm && (
                        <div>
                          <h5>{t('retailer-info-title-retailergm')}</h5>
                          <div className="person">
                            <dl>
                              <div>
                                <dt>{t('common-name')}</dt>
                                <dd>
                                  {contactInfo.retailer_gm.name}{' '}
                                  {contactInfo.retailer_gm.last_name}
                                </dd>
                              </div>
                              <div>
                                <dt>{t('common-email')}</dt>
                                <dd>{contactInfo.retailer_gm.email}</dd>
                              </div>
                              <div>
                                <dt>{t('common-phone')}</dt>
                                <dd>
                                  {contactInfo.retailer_gm.prefix_phone}{' '}
                                  {contactInfo.retailer_gm.phone}
                                </dd>
                              </div>
                            </dl>
                          </div>
                        </div>
                      )}

                      {contactInfo.first_sales_person && (
                        <div>
                          <h5>{t('retailer-info-title-saleperson1')}</h5>
                          <div className="person">
                            <dl>
                              <div>
                                <dt>{t('common-name')}</dt>
                                <dd>
                                  {contactInfo.first_sales_person.name}{' '}
                                  {contactInfo.first_sales_person.last_name}
                                </dd>
                              </div>
                              <div>
                                <dt>{t('common-email')}</dt>
                                <dd>{contactInfo.first_sales_person.email}</dd>
                              </div>
                              <div>
                                <dt>{t('common-phone')}</dt>
                                <dd>
                                  {contactInfo.first_sales_person.prefix_phone}{' '}
                                  {contactInfo.first_sales_person.phone}
                                </dd>
                              </div>
                            </dl>
                          </div>
                        </div>

                      )}
                      {contactInfo.second_sales_person && (
                        <div>
                          <h5>{t('retailer-info-title-saleperson2')}</h5>
                          <div className="person">
                            <dl>
                              <div>
                                <dt>{t('common-name')}</dt>
                                <dd>
                                  {contactInfo.second_sales_person.name || 'N/A'}{' '}
                                  {contactInfo.second_sales_person.last_name || ''}
                                </dd>
                              </div>
                              <div>
                                <dt>{t('common-email')}</dt>
                                <dd>
                                  {contactInfo.second_sales_person.email || 'N/A'}
                                </dd>
                              </div>
                              <div>
                                <dt>{t('common-phone')}</dt>
                                <dd>
                                  {contactInfo.second_sales_person.prefix_phone || 'N/A'}{' '}
                                  {contactInfo.second_sales_person.phone || ''}
                                </dd>
                              </div>
                            </dl>
                          </div>
                        </div>
                          )}
                        </>
                      ) : (
                        <div>{t('common-loading') + '...'}</div>
                  )}
                </main>
              </div>
            </section>
          </main>
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={3000}
            onClose={handleSnackbarClose}
          >
            <Alert severity="error" sx={{ width: '100%' }}>
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </div>
      ) : (
        <Navigate to="/login" />
      )}
    </>
  );
}

export default RetailerInfo;
